const baseUrl = "https://erp-elsalab.odoo.com";

export async function getAllOrders(token) {
  const url = `${baseUrl}/api/cs/orders`;
  try {
    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "text/plain" },
      body: JSON.stringify({ access_token: token }),
    });

    if (!res.ok) {
      let message = "";
      try {
        const j = await res.json();
        message = j?.message || j?.error || j?.detail || "";
      } catch (_) {
        message = await res.text().catch(() => "");
      }
      throw new Error(
        message || `Failed to fetch orders with status ${res.status}`
      );
    }
    const data = await res.json();
    return data?.data || [];
  } catch (e) {
    const msg = e?.message?.toLowerCase().includes("failed to fetch")
      ? "Network error or CORS blocked while fetching orders"
      : e?.message || "Failed to fetch orders";
    throw new Error(msg);
  }
}

export async function getOrderDetails(orderId, token) {
  const url = `${baseUrl}/api/cs/order/${orderId}`;
  try {
    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "text/plain" },
      body: JSON.stringify({ access_token: token }),
    });

    if (!res.ok) {
      let message = "";
      try {
        const j = await res.json();
        message = j?.message || j?.error || j?.detail || "";
      } catch (_) {
        message = await res.text().catch(() => "");
      }
      throw new Error(
        message || `Failed to fetch order details with status ${res.status}`
      );
    }
    const data = await res.json();
    return data?.data || null;
  } catch (e) {
    const msg = e?.message?.toLowerCase().includes("failed to fetch")
      ? "Network error or CORS blocked while fetching order details"
      : e?.message || "Failed to fetch order details";
    throw new Error(msg);
  }
}

// Create a sales order (quote) from cart items
// items: [{ id: string|number, qty: number, price: number }]
export async function createOrderFromCart(items, token) {
  const url = `${baseUrl}/api/cs/order/create`;
  try {
    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "text/plain" },
      body: JSON.stringify({
        access_token: token,
        lines: items.map((it) => ({
          id: Number(it.id),
          qty: Number(it.qty || 1),
          price: Number(it.price || 0),
        })),
      }),
    });

    if (res.status !== 201) {
      let message = "";
      try {
        const j = await res.json();
        message = j?.message || j?.error || j?.detail || "";
      } catch (_) {
        message = await res.text().catch(() => "");
      }
      throw new Error(
        message || `Failed to create order with status ${res.status}`
      );
    }
    const data = await res.json();
    const order = data?.data?.[0] || null;
    if (!order) throw new Error("Order not returned by API");
    return order;
  } catch (e) {
    const msg = e?.message?.toLowerCase().includes("failed to fetch")
      ? "Network error or CORS blocked while creating order"
      : e?.message || "Failed to create order";
    throw new Error(msg);
  }
}

// Confirm a sales order
export async function confirmOrder(
  orderId,
  token,
  phone,
  addressLine,
  addressCity,
  paymentMethod
) {
  const url = `${baseUrl}/api/cs/order/confirm`;
  try {
    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "text/plain" },
      body: JSON.stringify({
        access_token: token,
        so_id: Number(orderId),
        phone,
        address_line: addressLine,
        address_city: addressCity,
        payment_method: paymentMethod,
      }),
    });

    if (res.status === 200) return true;

    if (res.status > 400) {
      try {
        const decoded = await res.json();
        if (
          decoded?.type === "no data" &&
          decoded?.message === "order is already confirmed!"
        ) {
          return true;
        }
      } catch (_) {}
    }

    let message = "";
    try {
      const j = await res.json();
      message = j?.message || j?.error || j?.detail || "";
    } catch (_) {
      message = await res.text().catch(() => "");
    }
    throw new Error(
      message || `Failed to confirm order with status ${res.status}`
    );
  } catch (e) {
    const msg = e?.message?.toLowerCase().includes("failed to fetch")
      ? "Network error or CORS blocked while confirming order"
      : e?.message || "Failed to confirm order";
    throw new Error(msg);
  }
}
